function newsletter_openModal(email, firstName, lastName)
{
    $.get(url__api__newsletter_subscription, function (data) {
        $('[data-js="modal-newsletter"]').find('.newsletter-form').html(data.html);
        setTimeout(function () {
            $('[data-js="modal-newsletter"]').find("select").selectric();
            $('[data-js="modal-newsletter"]').find("#newsletter_email").val(email);
            $('[data-js="modal-newsletter"]').find("#newsletter_name").val(firstName);
            $('[data-js="modal-newsletter"]').find("#newsletter_last_name").val(lastName);
        }, 500);
        $('[data-js="modal-newsletter"]').modal('show');
    });
}

var newsletter_recaptchaLoad = function(form) {
    grecaptcha.execute(recaptcha_v3_key,
        { action: 'newsletter' }).then(function (token) {
        var recaptchaResponse = document.getElementById('newsletter_recaptcha');
        recaptchaResponse.value = token;

        $.post(url__api__newsletter_subscription, form.serializeArray(), function (data) {
            if (data.result) {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    'event': 'submit-form-newsletter-ok'
                });

                $('[data-js="modal-newsletter"]').modal('hide');
                $('#form-container').hide();
                $('#thanks_for_request').show();
                $('[data-js="modal-form-success"]').modal('show');
                if (typeof _callback__newsletter_subscription == 'function') {
                    _callback__newsletter_subscription();
                }
            }

            $('[data-js="modal-newsletter"]').find('.newsletter-form').html(data.html);
            setTimeout(function () {
                $('[data-js="modal-newsletter"]').find("select").selectric();
            }, 500);
        });
    });
};

function newsletter_check(email, callback)
{
    $.get(url__api__newsletter_subscription_check, {
        email: email
    }, function (data) {
        callback(data);
    });
}

// submit

$(document).on('submit', '#newsletter-form', function (e) {
    e.preventDefault();
    var form = $(this);
    newsletter_recaptchaLoad(form);
});
